import Vue from 'vue'
import App from '@/App.vue'
import axios from 'axios'
import wx from 'jweixin-module'
import base64 from 'base-64'
import storage from 'good-storage'
import router from '@/assets/js/router'
import Global from '@/assets/js/global'
import '@/assets/js/rem'

// require('@/assets/js/vconsole')

// 样式组件
import 'vant/lib/index.css';
import { Popup } from 'vant'
Vue.use( Popup )
import { DatetimePicker } from 'vant'
Vue.use( DatetimePicker )
import { Picker } from 'vant'
Vue.use( Picker )
import { Toast } from 'vant'
Vue.use( Toast )
import { Dialog } from 'vant'
Vue.use( Dialog )
import { Tab, Tabs } from 'vant'
Vue.use(Tab)
Vue.use(Tabs)
import { Overlay } from 'vant'
Vue.use(Overlay)
import { Checkbox } from 'vant'
Vue.use(Checkbox)
import { CheckboxGroup } from 'vant'
Vue.use(CheckboxGroup)
import { Form} from 'vant';
Vue.use( Form )
import { Field } from 'vant';
Vue.use(Field);


Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.wx = wx
Vue.prototype.base64 = base64
Vue.prototype.Global = Global
Vue.prototype.Storage = storage

axios.defaults.baseURL = 'https://api.jinlibx.com/api';
axios.interceptors.request.use( (config) => {
  // 在发送请求之前做些什么
  vueObj.$toast({
    type: 'loading',
    forbidClick: true,
    overlay: true
  })
  return config;
})

axios.interceptors.response.use( (response) => {
  // console.log(response.data.code)
  let resCode = response.data.code
  vueObj.$toast.clear()
  switch (resCode){
    case 40001:
      vueObj.$router.push('/authority')
      break
    default:
      return response
  }
}, function (error) {
  return Promise.reject(error);
})

//系统错误捕获
// const errorHandler = (error, vm)=>{
//   console.error('抛出全局异常');
//   console.error(vm);
//   console.error(error);
  
// }
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = (error)=> errorHandler(error,this);



const vueObj = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

export default vueObj